// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)
export const asyncLanguages: Record<string, () => unknown> = {
	cs: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-cs" */ '../../i18n/cs'
		),
	da: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-da" */ '../../i18n/da'
		),
	de: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-de" */ '../../i18n/de'
		),
	en: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-en" */ '../../i18n/en'
		),
	'en-GB': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-en_GB" */ '../../i18n/en_GB'
		),
	'en-ZZ': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-en_ZZ" */ '../../i18n/en_ZZ'
		),
	es: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-es" */ '../../i18n/es'
		),
	fi: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-fi" */ '../../i18n/fi'
		),
	fr: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-fr" */ '../../i18n/fr'
		),
	hr: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-hr" */ '../../i18n/hr'
		),
	hu: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-hu" */ '../../i18n/hu'
		),
	it: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-it" */ '../../i18n/it'
		),
	ja: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-ja" */ '../../i18n/ja'
		),
	ko: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-ko" */ '../../i18n/ko'
		),
	nb: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-nb" */ '../../i18n/nb'
		),
	nl: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-nl" */ '../../i18n/nl'
		),
	pl: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-pl" */ '../../i18n/pl'
		),
	'pt-BR': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-pt_BR" */ '../../i18n/pt_BR'
		),
	ru: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-ru" */ '../../i18n/ru'
		),
	sk: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-sk" */ '../../i18n/sk'
		),
	sl: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-sl" */ '../../i18n/sl'
		),
	sr: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-sr" */ '../../i18n/sr'
		),
	'sr-RS': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-sr_RS" */ '../../i18n/sr_RS'
		),
	'sr-YR': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-sr_YR" */ '../../i18n/sr_YR'
		),
	sv: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-sv" */ '../../i18n/sv'
		),
	th: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-th" */ '../../i18n/th'
		),
	tr: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-tr" */ '../../i18n/tr'
		),
	uk: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-uk" */ '../../i18n/uk'
		),
	vi: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-vi" */ '../../i18n/vi'
		),
	zh: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-zh" */ '../../i18n/zh'
		),
	'zh-TW': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-zh_TW" */ '../../i18n/zh_TW'
		),
};
